import 'taos';

const MODULE = document.querySelectorAll('[data-module="header"]');

class Header {
    constructor() {
        this.components = MODULE;
        this.fontScale = 1;
        this.minScale = 0.8;
        this.maxScale = 1.4;
        this.step = 0.1;
        this.scrollThreshold = 150;
        this.lastScrollY = window.scrollY || 0;
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const menuMobileBtn = component.querySelector('.btn-menu-mobile');
            const menuMobileContent = component.querySelector('.menu-mobile-content')

            if (menuMobileBtn) {
                menuMobileBtn.addEventListener('click', () => this.menuMobile(menuMobileContent))
            }

            const btnGoTop = document.querySelector('.go-top');
            if (btnGoTop) {
                btnGoTop.addEventListener('click', () => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth',
                    });
                })
            }
        });

        this.initHashScroll();
    }

    getHeaderHeight() {
        const header = this.components[0] || document.querySelector('[data-module="header"]');
        return header ? header.offsetHeight : 0;
    }

    getComponentByHash(hash = window.location.hash) {
        if (!hash || hash === '#') return null;

        const id = decodeURIComponent(hash.slice(1));
        if (!id || !/^[A-Za-z][\w:-]*$/.test(id)) return null;

        const target = document.getElementById(id);
        if (!target || !target.hasAttribute('data-module')) return null;

        return target;
    }

    scrollToComponent(target) {
        if (!target) return;

        const top = target.getBoundingClientRect().top + window.scrollY - this.getHeaderHeight();

        window.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth',
        });
    }

    scrollToHash(hash = window.location.hash) {
        const target = this.getComponentByHash(hash);
        if (!target) return false;

        this.scrollToComponent(target);
        return true;
    }

    initHashScroll() {
        const handleHash = () => {
            requestAnimationFrame(() => this.scrollToHash());
        };

        if (window.location.hash) {
            // Aguarda o layout (imagens/fontes) antes de scrollar no carregamento
            window.addEventListener('load', handleHash, { once: true });
            handleHash();
        }

        window.addEventListener('hashchange', handleHash);

        document.addEventListener('click', (event) => {
            const link = event.target.closest('a[href*="#"]');
            if (!link) return;

            const href = link.getAttribute('href');
            if (!href) return;

            let url;
            try {
                url = new URL(href, window.location.href);
            } catch {
                return;
            }

            if (url.pathname !== window.location.pathname || !url.hash) return;

            const target = this.getComponentByHash(url.hash);
            if (!target) return;

            event.preventDefault();

            if (window.location.hash !== url.hash) {
                history.pushState(null, '', url.hash);
            }

            this.scrollToComponent(target);
        });
    }

    menuMobile(menuMobileContent) {
        menuMobileContent.classList.toggle('is-open');
        menuMobileContent.closest('header').classList.toggle('is-menu-open');
        document.body.classList.toggle('block-scroll');
    }
}

(() => {
    if (MODULE.length) {
        new Header();
    }
})();

export default Header;
